const ClassA = 'https://websiteoss.ecoflow.com/upload/image/1744601121358/20250414-112219.png';
const ClassB = 'https://websiteoss.ecoflow.com/upload/image/1730360834391/classB.png';
const ClassC = 'https://websiteoss.ecoflow.com/upload/image/1730359207989/classC.png';
const SUV = 'https://websiteoss.ecoflow.com/upload/image/1730451078332/SUV.png';
const Pick_Up = 'https://websiteoss.ecoflow.com/upload/image/1730771066569/Pick%20Up.png';
const Travel_Trailer = 'https://websiteoss.ecoflow.com/upload/image/1730771066410/Group.png';
const Fifth_wheels = 'https://websiteoss.ecoflow.com/upload/image/1744601121542/20250414-112507.png';
// 30A RV Kit: Class B Vans, Class C Motorhomes, Travel Trailers
// 50A RV Kit: , 
// Auto Kit: 


export const US_Bundles = [
    {
        title: 'bundles.bundle1_title',
        name: 'bundles.bundle1_name',
        productId: '7352587878473',
        variantId: '41830211682377',
        carList: [
            {
                carImg: ClassB,
                carText: 'Class B Vans',
            },
            {
                carImg: ClassC,
                carText: 'Class C Motorhomes',
            },
            {
                carImg: Travel_Trailer,
                carText: 'Travel Trailers',
            },
        ],

        subsTitle: 'bundles.subsTitle',
        subs: [
            {
                title: 'bundles.subs.battery',
                limit: 4,
                parentVariantId: '41830211682377',
                productId: '7352583651401',
                variantId: '41830186745929',
            },
        ],
    },
    {
        title: 'bundles.bundle2_title',
        name: 'bundles.bundle2_name',
        carList: [
            {
                carImg: ClassA,
                carText: 'Class A Motorhomes',
            },
            {
                carImg: Fifth_wheels,
                carText: 'Fifth Wheels',
            },
        ],
        productId: '7352587878473',
        variantId: '41830211715145',
        subsTitle: 'bundles.subsTitle',
        subs: [
            {
                title: 'bundles.subs.battery',
                limit: 4,
                parentVariantId: '41830211715145',
                productId: '7352583651401',
                variantId: '41830186745929',
            },
        ],
    },
    {
        title: 'bundles.bundle3_title',
        name: 'bundles.bundle3_name',
        carList: [
            {
                carImg: SUV,
                carText: 'Overland SUVs',
            },
            {
                carImg: Pick_Up,
                carText: 'Pick-up Trucks',
            },
        ],
        productId: '7352587878473',
        variantId: '41830211747913',
        subsTitle: 'bundles.subsTitle',
        subs: [
            {
                title: 'bundles.subs.battery',
                limit: 4,
                parentVariantId: '41830211747913',
                productId: '7352583651401',
                variantId: '41830186745929',
            },
        ],
    },
];
